import {CreateSheet} from 'aphrodite';
import {TooltipBg, WhiteText} from 'src/themes/colors';

export default CreateSheet({
    tooltip_container: {
        maxWidth: 300,
        zIndex: 100000000,
        padding: '4px 8px',
        fontSize: '0.75rem',
        fontWeight: 700,
        borderRadius: 4,
    },
    stub: {
        display: 'inline-block',
    },
});

export const ColorVariants = CreateSheet({
    dark: {
        color: WhiteText,
        backgroundColor: TooltipBg,
        ':nth-child(1n) .tooltip-arrow': {
            fill: TooltipBg,
        },
    },
    light: {
        color: '#000000',
        backgroundColor: '#ffffff',
        border: `1px solid #DADADA`,
        boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.15)',
        ':nth-child(1n) .tooltip-arrow': {
            fill: '#ffffff',
        },
    },
});
